"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAccessibilityPropSDKFactory = void 0;
const composeSDKFactories_1 = require("../composeSDKFactories");
const accessibilitySDKFactories_1 = require("./accessibilitySDKFactories");
const ariaFactoryMap = {
    enableAriaLabel: accessibilitySDKFactories_1.createAriaLabelSDK,
    enableAriaDescribedBy: accessibilitySDKFactories_1.createDescribedBySDK,
    enableAriaLabelledBy: accessibilitySDKFactories_1.createLabelledBySDK,
    enableAriaAtomic: accessibilitySDKFactories_1.createAtomicSDK,
    enableAriaBusy: accessibilitySDKFactories_1.createBusySDK,
    enableAriaCurrent: accessibilitySDKFactories_1.createCurrentSDK,
    enableAriaExpanded: accessibilitySDKFactories_1.createExpandedSDK,
    enableAriaLive: accessibilitySDKFactories_1.createLiveSDK,
    enableAriaOwns: accessibilitySDKFactories_1.createOwnsSDK,
    enableAriaControls: accessibilitySDKFactories_1.createControlsSDK,
    enableAriaRoleDescription: accessibilitySDKFactories_1.createRoleDescriptionSDK,
    enableAriaRelevant: accessibilitySDKFactories_1.createRelevantSDK,
    enableAriaErrorMessage: accessibilitySDKFactories_1.createErrorMessageSDK,
    enableAriaHidden: accessibilitySDKFactories_1.createAriaHiddenSDK,
    enableAriaPressed: accessibilitySDKFactories_1.createAriaPressedSDK,
    enableAriaHaspopup: accessibilitySDKFactories_1.createAriaHaspopupSDK,
};
const accessibilityFactoryMap = {
    enableLegacyAriaLabel: accessibilitySDKFactories_1.legacyAriaLabelSDKFactory,
    enableScreenReader: accessibilitySDKFactories_1.screenReaderSDKFactory,
    enableRole: accessibilitySDKFactories_1.createRoleSDK,
    enableTabIndex: accessibilitySDKFactories_1.createTabIndexSDK,
};
const createAriaAttributesSDKFactory = (ariaAttributeOptions) => {
    const sdkFactories = [];
    Object.entries(ariaAttributeOptions).forEach(([option, enabled]) => enabled &&
        ariaFactoryMap[option] &&
        sdkFactories.push(ariaFactoryMap[option]));
    const ariaAttributesSDKFactory = api => ({
        ariaAttributes: (0, composeSDKFactories_1.composeSDKFactories)(...sdkFactories)(api),
    });
    return ariaAttributesSDKFactory;
};
const createAccessibilityPropSDKFactory = ({ enableLegacyAriaLabel = false, enableAriaLabel = true, enableAriaDescribedBy = true, enableAriaLabelledBy = true, enableAriaAtomic = false, enableAriaBusy = false, enableAriaHidden = false, enableAriaPressed = false, enableAriaHaspopup = false, enableAriaCurrent = false, enableAriaExpanded = false, enableAriaLive = false, enableAriaOwns = false, enableAriaControls = false, enableAriaRoleDescription = false, enableAriaRelevant = false, enableRole = false, enableTabIndex = false, enableAriaErrorMessage = false, enableScreenReader = false, } = {}) => api => {
    const sdkFactories = [];
    const ariaAttributesOptions = {
        enableAriaLabel,
        enableAriaDescribedBy,
        enableAriaLabelledBy,
        enableAriaAtomic,
        enableAriaBusy,
        enableAriaCurrent,
        enableAriaExpanded,
        enableAriaLive,
        enableAriaOwns,
        enableAriaControls,
        enableAriaRoleDescription,
        enableAriaRelevant,
        enableAriaErrorMessage,
        enableAriaHidden,
        enableAriaPressed,
        enableAriaHaspopup,
    };
    const otherAccessibilityOptions = {
        enableLegacyAriaLabel,
        enableScreenReader,
        enableRole,
        enableTabIndex,
    };
    const enableAriaAttributes = Object.values(ariaAttributesOptions).some(optionEnabled => optionEnabled);
    if (enableAriaAttributes) {
        const ariaAttributesSDKFactory = createAriaAttributesSDKFactory(ariaAttributesOptions);
        sdkFactories.push(ariaAttributesSDKFactory);
    }
    Object.entries(otherAccessibilityOptions).forEach(([option, enabled]) => enabled &&
        accessibilityFactoryMap[option] &&
        sdkFactories.push(accessibilityFactoryMap[option]));
    const accessibilitySdkFactory = (0, composeSDKFactories_1.composeSDKFactories)(...sdkFactories);
    return { accessibility: accessibilitySdkFactory(api) };
};
exports.createAccessibilityPropSDKFactory = createAccessibilityPropSDKFactory;
//# sourceMappingURL=accessibilityPropsSDKFactory.js.map